<template>
<div v-can="'lead_masks.list'">
  <div class="search-container">
    <searchbar :value="query.search" @search="search" :model="model"></searchbar>
  </div>
  <general-listing
    @sorting="sorting"
    @itemDelete="itemDelete"
    :loading="loading"
    :data="items"
    :structure="collectionData"
    :params="{ global_sorting: true, sort_by: this.query.sort_by, sort_order: this.query.sort_order}"
    model="lead_mask"
    :has_searched="has_searched"
  />
  <pagination
    @goToPage="goToPage"
    :page="page"
    :total-pages="total_pages"
  />
  <lead-mask-create/>
</div>
</template>
<script>
import Api from '@/api/LeadMask'
import Ui from '@/classes/Ui'
import {collectionMixin} from '@/components/mixins/Collection'
import { EventBus } from '@/EventBus.js'
import Searchbar from '@/components/layouts/partials/Searchbar'
import LeadMaskCreate from './LeadMaskCreate'
import GeneralListing from '@/components/helpers/Specific/GeneralListing'

let structure = [
  { name: 'id', sortable: true, credentials: 'root'},
  { name: 'name', type: 'show_with_edit_link', sortable: true},
  { name: 'language', sortable: true},
  { name: 'organization.name', sortable: true, credentials: 'root', alias: 'organization_name'},
  { name: 'action', type: 'crud_action_folded' }
]

let default_sort_by = "created_at"
let default_sort_order = "DESC"
let default_filters = {}

export default {
  mixins: [collectionMixin],
  components: {
    Searchbar,
    LeadMaskCreate,
    GeneralListing
  },
  data(){
    return {
      model: "lead_masks",
      api: new Api(),
      collectionData: structure,
      title: "ui.pages.lead-masks",
      loading: false,
      query: {},
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_LEAD_MASKS',
        routerName: 'lead_masks',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    }
  },
  created(){
    //  In case we generate a query, we create it before to be able to retrieve it in collection and display the specific list.
    this.initQuery()
  },
  mounted(){
    if (this.page != Ui.getCurrentPageLeadMasks()) {
      this.goToPage(Ui.getCurrentPageLeadMasks())
    }
    Ui.setHeaderButtons([
      { name: 'lead_mask',
        action: "lead_masks.add_popup",
        classes: "btn-primary"
      }
    ])
    EventBus.$off('lead_mask_duplicate')
    EventBus.$on('lead_mask_duplicate', this.duplicate)
  },
  methods: {
    duplicate(payload){
      this.api.duplicate(payload.id).then(data=>{
        this.retrieve()
        let newForm = data.resource
        let route = { name: 'lead_mask_edit', params: { id: newForm.id }}
        this.$router.push(route)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// LeadMasks.vue?0000cede